<template>
  <div class="swiperContent" ref="content">
    <swiper class="swiper-container" :options="swiperOption" v-if="showSwiper">
      <swiper-slide v-for="(floatingBanner, index) in floatingBannerVoList" class="swiper-slide" :key="index">
        <div class="banner-contain">
          <div class="banner-img">
            <img v-if="$store.getters.getObject(floatingBanner.langMap).bannerImage" :src="$store.getters.getObject(floatingBanner.langMap).bannerImage" :alt="$store.getters.getObject(floatingBanner.langMap).bannerName" />
            <img v-if="!$store.getters.getObject(floatingBanner.langMap).bannerImage" src="../images/floating_default.png" :alt="$store.getters.getObject(floatingBanner.langMap).bannerName" />
            <div class="banner-divide"></div>
          </div>
          <div class="banner-group">
            <div class="banner-content">
              <div class="banner-title">
                <span>{{ $store.getters.getObject(floatingBanner.langMap).bannerName }}</span>
              </div>
              <div class="banner-text">
                {{ $store.getters.getObject(floatingBanner.langMap).content }}
              </div>
            </div>
            <div class="banner-btn" @click="goDetail($store.getters.getObject(floatingBanner.langMap).buttonUrl)">
              <div class="btn-primary banner-btn-250 font-size-14">
                <a href="javascript:;" style="color: inherit">{{ $t("message.Let get started") }}</a>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div class="banner-close-btn" @click="closeBanner">
      <a href="javascript:;" style="color: inherit"><i class="icon-close"></i></a>
    </div>
    <div class="banner-deco-10">
      <img src="../images/deco-10.png" />
    </div>
    <div class="banner-deco-22">
      <img src="../images/deco-22.png" />
    </div>

    <div class="swiper-banner-prev" :class="{'hiddenBtn': !this.showBtn}" slot="button-prev">
      <i class="icon-arrow-down"></i>
    </div>
    <div class="swiper-banner-next" :class="{'hiddenBtn': !this.showBtn}" slot="button-next">
      <i class="icon-arrow-down"></i>
    </div>
  </div>
</template>
<script>
import { EventBus } from "@/javascripts/eventBus.js";

export default {
  name: "SwiperBanner",
  data() {
    return {
      showSwiper: false,
      showBtn: true,
      swiperOption: {
        loop: false,
        spaceBetween: 100,
        navigation: {
          prevEl: ".swiper-banner-prev",
          nextEl: ".swiper-banner-next",
        },
      },
      isClose: false,
    };
  },
  props: {
    floatingBannerVoList: {
      type: Array,
    }
  },
  methods: {
    init: function () {},
    setWidth: function () {
      if( this.floatingBannerVoList.length > 1 ) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
      if( this.floatingBannerVoList.length > 1 ) {
        this.swiperOption = {
          loop: false,
          spaceBetween: 100,
          navigation: {
            prevEl: ".swiper-banner-prev",
            nextEl: ".swiper-banner-next",
          },
        }
      }
      this.showSwiper = false;
      this.$nextTick(() => {
        this.showSwiper = true;
      });
    },
    closeBanner: function () {
      EventBus.$emit("closeBanner");
    },
    goDetail: function (url) {
      let https = "https://";
      let http = "http://";
      if(url.indexOf(https) < 0 && url.indexOf(http) < 0) {
        url = "https://" + url
      }
      window.open(url, "_blank")
      // if (this.$store.state.isPreview) return;
      // this.$router.push({
      //   path: url,
      //   query: { lang: this.$store.state.language },
      // });
      // window.scrollTo(0, 0);
    },
  },
  components: {},
  computed: {
    innerwidth() {
      return this.$store.state.innerWidth;
    },
    language() {
      return this.$store.state.language;
    },
    fontsize() {
      return this.$store.state.fontSize;
    },
  },
  watch: {
    innerwidth(news, old) {
      // this.showSwiper = false;
      // this.setWidth();
    },
    floatingBannerVoList: function (n, o) {
      this.setWidth();
    },
    language: function (n, o) {
      this.setWidth();
    },
    fontsize: function (n, o) {
      this.setWidth();
    },
  },
  mounted() {
    this.setWidth();
    var that = this;
    setTimeout(function () {
      that.setWidth();
    }, 200);
  },
};
</script>
<style scoped>
</style>